//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FacultyHeader from '@/components/redesign/coding/FacultyHeader'
import StartSection from '@/components/redesign/math/StartSection'
import FeaturesSection from '@/components/redesign/math/FeaturesSection'
import WorldSection from '@/components/redesign/math/WorldSection'
import CommentSection from '@/components/redesign/math/CommentSection'
import CoursesSection from '@/components/redesign/math/CoursesSection'
import ClaimSection from '@/components/redesign/coding/ClaimSection'
import RoadmapSection from '@/components/redesign/coding/RoadmapSection'

export default {
  name: 'MathTop',
  components: {
    FacultyHeader,
    StartSection,
    ClaimSection,
    RoadmapSection,
    FeaturesSection,
    WorldSection,
    CommentSection,
    CoursesSection,
  },
}
